import { ComponentBootstrap } from '@demant/wdh-react-bootstrap';
import BlogAuthorApp from './react-blog-author';
var ReactBlogAuthor = new ComponentBootstrap('blog-author', '.component');
ReactBlogAuthor.reactApp = BlogAuthorApp;
ReactBlogAuthor.run();